import React from 'react';

const svgProps = {
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
  'aria-hidden': true,
  focusable: false,
};

function Stroke({ children, width = 1.75 }) {
  return (
    <g stroke="currentColor" strokeWidth={width} strokeLinecap="round" strokeLinejoin="round">
      {children}
    </g>
  );
}

/**
 * Ikony dolnej nawigacji — spójny styl stroke z resztą aplikacji (EventCardIcon).
 */
export function BottomNavSvgIcon({ name, className = 'bottom-nav-icon-svg', size = 24 }) {
  switch (name) {
    case 'discover':
      return (
        <svg {...svgProps} className={className} width={size} height={size}>
          <Stroke>
            <path d="M12 21.2c-3.2-3.6-6-7-6-10.5a6 6 0 1 1 12 0c0 3.5-2.8 6.9-6 10.5z" />
          </Stroke>
          <circle cx="12" cy="10.5" r="1.6" fill="currentColor" fillOpacity="0.35" />
        </svg>
      );
    case 'events':
      return (
        <svg {...svgProps} className={className} width={size} height={size}>
          <Stroke>
            <rect x="4" y="5" width="16" height="15" rx="2.2" />
            <path d="M4 10h16M8 3.5v3M16 3.5v3" />
            <path d="M12 12.5V16l2.5 1.5" />
          </Stroke>
        </svg>
      );
    case 'notifications':
      return (
        <svg {...svgProps} className={className} width={size} height={size}>
          <Stroke>
            <path d="M6 10a6 6 0 1 1 12 0v3.2l2 4.3H4L6 13.2V10z" />
            <path d="M10 20.5h4" />
          </Stroke>
        </svg>
      );
    case 'profile':
      return (
        <svg {...svgProps} className={className} width={size} height={size}>
          <Stroke>
            <circle cx="12" cy="8" r="3.4" />
            <path d="M5.5 20a6.5 6.5 0 0 1 13 0" />
          </Stroke>
        </svg>
      );
    case 'settings':
      return (
        <svg {...svgProps} className={className} width={size} height={size}>
          <Stroke width={1.65}>
            <circle cx="12" cy="12" r="3.2" />
            <path d="M12 1.8v2.6M12 19.6v2.6M3.5 12h2.6M17.9 12h2.6M5.4 5.4l1.8 1.8M16.8 16.8l1.8 1.8M5.4 18.6l1.8-1.8M16.8 7.2l1.8-1.8" />
          </Stroke>
        </svg>
      );
    case 'create':
      return (
        <svg {...svgProps} className={className} width={size} height={size}>
          <Stroke width={2.1}>
            <path d="M12 5.5v13M5.5 12h13" />
          </Stroke>
        </svg>
      );
    default:
      return null;
  }
}
